import React, { useEffect, useState } from "react";
import { awsInstance } from "../../actions/api";
import { useRecoilValue, useRecoilState } from "recoil";
import ModalForAdmin from "../modal/ModalForAdmin";
import { userState, indicatorState, adminListState } from "../../stores/atoms";
import AdminListItem from "./AdminListItem";
import Loading from './../Loading';

function Admin() {
  const user = useRecoilValue(userState);
  const [, setIndicator] = useRecoilState(indicatorState);
  const [modalShow, setModalShow] = useState(false);
  const [adminList, setAdminList] = useRecoilState(adminListState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIndicator("홈 > 관리자 관리");

    const getAdminList = async () => {
      try {
        setLoading(true);
        const { data } = await awsInstance.get("/business/admin", {
          params: {
            id: user.company_id
          },
        });
        if (data.code === "SUCCESS") {
          const list = data.data;
          setAdminList(list);
        } else {
          setAdminList([]);
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoading(false);
      }
    };
    getAdminList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDeleteAdmin = async (id) => {
    if (adminList.length <= 1) {
      alert("관리자는 최소 1명이어야 합니다.");
      return false;
    }
    if (id === user.business_user_id) {
      alert("자기 자신을 삭제할 수 없습니다.");
      return false;
    }
    if (window.confirm("해당 관리자를 삭제하시겠습니까?")) {
      try {
        const params = new URLSearchParams({
          id: id
        });
        setLoading(true);
        const { data } = await awsInstance.delete(`/business/admin?${params}`);
        if (data.code === "SUCCESS") {
          setAdminList(adminList.filter((admin) => admin.id !== id));
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoading(false);
      }
    } else {
      return false;
    }
  };

  return (
    <>
    <div className="admin">
      <h5 className="title">관리자 관리</h5>
      <p className="txt-gray">
        직원을 관리자로 지정하거나 삭제할 수 있습니다.
      </p>
      <div className="display-flex justify-content-between">
        <p className="txt-gray mt-3 font-bold">
          <span className="txt-blue">{adminList.length}건</span>이 검색되었습니다.
        </p>
        <button
          className="btn-blue-md p-1"
          onClick={() => setModalShow(true)}>
          관리자 지정
        </button>
      </div>
      <table className="table table-list">
        <tbody>
          <tr className="background-gray txt-white">
            <th className="width-10">
              <span>관리자명</span>
            </th>
            <th className="width-15">권한</th>
            <th className="width-30">이메일</th>
            <th className="width-20">휴대폰 번호</th>
            <th className="width-15">부서명</th>
            <th className="width-15">지정일</th>
            <th className="width-10">삭제</th>
          </tr>
          {adminList.length !== 0 &&
            adminList.map((admin) => {
              return (
                <AdminListItem
                  key={admin.id}
                  admin={admin}
                  onRemove={onDeleteAdmin}
                />
              );
            })}
          {adminList.length === 0 && (
            <>
              <tr>
                <th colSpan="7">
                  <span className="txt-dark-gray">
                    등록된 관리자가 없습니다.
                  </span>
                </th>
              </tr>
            </>
          )}
        </tbody>
      </table>
      <ModalForAdmin show={modalShow} onHide={() => setModalShow(false)} />
    </div>
    <Loading loading={loading} />
    </>
  );
}

export default Admin;
